import styled from 'styled-components';

export const DocList = styled.div`
  padding: 5px;
  background-color: ${(props) => props.bgColor || '#FCEFD8'};
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  border-radius: 4px;
  position: relative;
  height: ${(props) =>
    props.isExpanded || props.documnetsLength <= 1
      ? 'auto'
      : 'calc(1.5 * 48px + 45px)'}; /* Adjust for document height */
  overflow: hidden;

  /* Apply gradient mask only when not expanded and there are more than one document */
  mask-image: ${(props) =>
    props.isExpanded || props.documnetsLength <= 1
      ? 'none'
      : 'linear-gradient(to bottom, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0))'};
  -webkit-mask-image: ${(props) =>
    props.isExpanded || props.documnetsLength <= 1
      ? 'none'
      : 'linear-gradient(to bottom, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0))'};
`;
